<lib-generic-type-ahead-multiselect
    [source]="items"
    [(selectedItems)]="selectedItems"
    (selectedItemsChange)="onSelectedItemsChange()"
    [config]="{
        defaultText: 'Select ' + label,
        multiple: true,
        itemDisplayKey: additionalInfo?.itemDisplayKey ?? 'name',
        itemTemplate: customItemTemplate
    }"
    [placeholder]="'Search Bids'"
    (textChange)="onEntityTextChange($event)"
>
</lib-generic-type-ahead-multiselect>
<ng-template #customItemTemplate let-data>
    <app-custom-menu-item
        [inputText]="data.inputText"
        [title]="data.object.name"
        [subtitle]="data.object?.id?.toString() ?? ''"
    >
    </app-custom-menu-item>
</ng-template>
